import *as THREE from 'three'
import { GLTF } from "constants/threeConstants";
import Viewer from "../viewer";
import FreestyleState from "types/freestyle.types";
import FreestyleAction, { FActionObject } from "./FreestyleAction";
import { FreestyleItem, FreestyleItemCond, NativeAnimation, CamposValue } from "types/data";
import { FreestyleButtonEventData } from "types/freestyle.action.types";
import DynamicWaterPressure from "lib/dynamicWaterPressure";
import { incrementCounter } from "actions/freestyle";
import isDev from "lib/isDev";
import { AnimationAction } from "three/src/animation/AnimationAction";
import PhysicEngine from '../PhysicEngine/PhysicEngine';
import DynamicVacuum from 'lib/dynamicVacuum';

interface Props {
  truck: GLTF
  freestyleModels: GLTF[],
  maps: any
  viewerApi: Viewer,
  data: FreestyleState
  freestyleModel: GLTF
  onIncrement: (...args: Parameters<typeof incrementCounter>) => void
}

export interface NativeAnimationsItem {
  name: string;
  animation: DynamicWaterPressure | DynamicVacuum;
}

export default class FreestyleController {
  props: Props
  mixers: {
    mixer: THREE.AnimationMixer,
    item: GLTF,
    clock: THREE.Clock
  }[]
  actions: FreestyleAction[]
  active = false
  physicEngine?: PhysicEngine
  actionClips: any

  constructor(props: Props) {
    const { isConditionDone } = this
    this.props = props

    // this.mixers = {
    //   root: new THREE.AnimationMixer(this.props.truck.scene),
    //   boom: new THREE.AnimationMixer(this.props.boom.scene),
    // }
    this.mixers = [props.truck, ...props.freestyleModels].map(item => ({
      mixer: new THREE.AnimationMixer(item.scene), item, clock: new THREE.Clock()
    }))

    
    
    console.log(this.props.data.items)
    
    const nativeAnimations: NativeAnimationsItem[] = this.props.data.items
      .reduce((acc: NativeAnimation[], item) => [
        ...acc,
        ...item.actions.filter(item => item.nativeAnimation).map(item => item.nativeAnimation!)
      ], [])
      .map(item => {
        switch(item.name) {
          case 'dynamicVacuum':
            console.log(item.name)
            return ({
              name: item.name,
              animation: new DynamicVacuum(this.props.viewerApi.freestyleVacuum)
            })
          
          default:
          return ({
              name: 'dynamicWaterNative',
              animation: new DynamicWaterPressure(this.props.truck.scene.getObjectByName(item.meshName)!)
            })
        }
      })

    const actions = this.mixers.reduce((acc: {action: AnimationAction, name: string}[], item) => [
      ...acc,
      ...item.item.animations.map((an) => ({action: item.mixer.clipAction(an), name: an.name}))
    ], [])

    this.actionClips = actions

 

    const getActionByName = (name?: string) => {
      const targetAction = actions.find(item => item.name === name)
      return targetAction ? targetAction.action : undefined
    }
    
    this.actions = this.props.data.items.map(data => new FreestyleAction({
      data, 
      isConditionDone,
      getActionByName,
      nativeAnimations,
      onIncrement: (dir: 1 | -1) => props.onIncrement(data.id, dir)
    }))
  }

  init() {
    this.active = true
    this.props.viewerApi.initFreestyle()
    
    if(!isDev) {
      const staticSoundAction = this.actions.find(item => item.counter && item.counter.type === 'graphicState')

      // setTimeout(() => {
        staticSoundAction!.soundEffects[0].play()
      // }, 0)
      
    } 

    this.physicEngine = new PhysicEngine({
      freestyle: this.props.freestyleModel.scene,
      actions: this.actionClips.reduce((acc: any, item: any) => ({...acc, [item.name]: item.action}), {}),
      maps: this.props.maps
    })

    this.props.viewerApi.updateFakeControlsPosition()
  }

  dispose() {
    this.active = false

    this.physicEngine!.dispose()
    this.physicEngine = undefined
    this.actions.forEach(item => item.dispose())
  }
  
  onActiveItem(item: FreestyleItem, prevCamPos?: CamposValue) {
    
    if(!isDev) {
      const [x, y, z] = item.campos.camera
      const [nx, ny, nz] = prevCamPos ? prevCamPos.camera : [1945, 1945, 1945]
      if(x === nx && ny === ny && nz === nz) return
      
      this.props.viewerApi.goToPosition(item.campos).then(() => this.props.viewerApi.updateFakeControlsPosition())
    }
  }

  remoteEvent = ({name, type, greenPressed}: FreestyleButtonEventData) => {
    const targetAction = this.actions.find(item => 
      item.actions.some(a => 
        a.buttons.map(i => i.name).includes(name || 'neverwillbeincluded') && a.greenButton === greenPressed
      )
    )
    
    if(!name) {
      this.actions.forEach(item => item.onButtonEvent(name, greenPressed, type))
    }

    if(targetAction) {
      return targetAction.onButtonEvent(name, greenPressed, type)
    }
  }

  getProgressOfClip = (c: any) => c.time / c._clip.duration

  
  isConditionDone = (condition: FreestyleItemCond, dir?: number) => {
    const getClipByName = (name: string) => { 
      return  this.actions.reduce((acc: FActionObject | undefined, action) => acc ?
          acc
          :
          action.actions.find(item => item.clipName === name),
          undefined
      )
    }

    
    const targetActionClip = getClipByName(condition.target) 

    if(targetActionClip) {
      const condProggress = (condition.progress / 100)
      
      //@ts-ignore
      const progress = this.getProgressOfClip(targetActionClip.animationAction)

      
      if(condition.type === 'lock') {
        const isLocked = progress !== condProggress && dir === condition.lock!.actionDir

        const currentActionClip = getClipByName(condition.lock!.ownTarget)!
        const currentACProgress = this.getProgressOfClip(currentActionClip.animationAction)
    
        //@ts-ignore
        currentActionClip.animationAction.min_progress = isLocked ? condition.lock!.min : 0 
        //@ts-ignore
        currentActionClip.animationAction.locked_dir = condition.lock!.actionDir 

        const res = !isLocked ? true : (currentACProgress >= (condition.lock!.min / 100)) 

        return res
      }
      if(condition.type === 'min') {
        return condProggress <= progress
      }
      return condProggress === progress
    }
  }

  update(delta: number) {
    this.mixers.forEach(({mixer, clock}) => {
      try {
        mixer.update(clock.getDelta())
      } catch {

      }
    })

    if(this.physicEngine) this.physicEngine.update(delta)

    this.actions.forEach((item) => {
      const anims = item.actions.map(i => i.animationAction).filter(i => i)

      anims.map((item) => {
        if(!item) return
        const condProggress = this.getProgressOfClip(item!)

        //@ts-ignore
        if(item!.min_progress !== undefined) {
          //@ts-ignore
          const min_p = item!.min_progress
          
          
          if((min_p / 100 >= condProggress ) && min_p !== 0) item.paused = true
          
        }
      })
    })

    this.actions.forEach(item => 
      item.actions.forEach(item => item.nativeAnimation && item.nativeAnimation.update())
    )
  }
}